import BannerApp from "@/components/BannerApp"
import HtmlApp from "@/components/HtmlApp"
import VitrineApp from "@/components/vitrine/VitrineApp"
import MidiaApp from "@/components/midia/MidiaApp"
import BannerFixoApp from "@/components/banner-fixo/BannerFixoApp"
import TitleApp from "@/components/title/TitleApp"
import MenuApp from "@/components/menu/MenuApp.tsx";
import type { VitrineAppProps } from "@/components/vitrine/types/vitrineApp.props"
import type { MidiaAppProps } from "@/components/midia/midia.props.ts"
import type { BannerFixoAppProps } from "@/components/banner-fixo/banner-fixo.props"
import type { TitleAppProps } from "@/components/title/title.props"
import type { MenuAppProps } from "@/components/menu/menu.props.ts"


export default class Components {
    // eslint-disable-next-line
    banner(props: any) {
        return new BannerApp(props)
    }

    html(props: { id: string; html: string }) {
        return new HtmlApp(props)
    }

    vitrine(props: VitrineAppProps) {
        return new VitrineApp(props)
    }

    midia(props: MidiaAppProps) {
        return new MidiaApp(props)
    }

    bannerFixo(props: BannerFixoAppProps) {
        return new BannerFixoApp(props)
    }

    title(props: TitleAppProps) {
        return new TitleApp(props)
    }

    menu(props: MenuAppProps) {
        return new MenuApp(props)
    }
}
